import _ from 'underscore';
import Backbone from 'backbone';
import Mn from 'backbone.marionette';
import PageApp from 'pageApp';
import Coremetrics from '@component/common/src/util/Coremetrics';
import LazyLoad from '@core/util/lazyload';
import IntersectionObserver from '@core/util/intersection-observer';
import Util from '../util/Util';
import template from '../templates/partials/content-thumbnail.hbs';

module.exports = Mn.ItemView.extend({
  template,
  events: {
    'click .contentImage': 'onContentImageClick',
  },
  initialize() {
    if (!_.isUndefined(this.model)) {
      this.model = new Backbone.Model(this.model.get('content'));
      this.model.set('properties', PageApp.getMeta('properties'));
    }
    this.pageName = Util.getCMPageForContent(this.options.config.zone);
  },
  onContentImageClick(e) {
    // const isCollection = this.model.get('isCollection') || false;
    Coremetrics.createLinkClickTag({
      href: `${e.currentTarget.href}?cm_sp=${this.pageName}-_-modified_pros-_-hero_image`,
    });
  },
  onRender() {
    if (!_.isUndefined(this.model) && this.model.get('properties').isElegantLoading) {
      this.lazyLoadContentThumbnail();
    }
  },
  lazyLoadContentThumbnail() {
    const lli = new LazyLoad(null, []);
    const io = new IntersectionObserver(target => lli.ready.then(() => lli.load(target, true)));
    io.ready.then(() => io.subscribe([...this.$el.context.querySelectorAll('img.lazy')]));
  },
});
